export default __webpack_public_path__ + "static/media/linkedin-grey.58421fb5.svg";